import { usePage } from '@/components/providers/PageProvider'
import { unslugify } from '@/utils/commonUtil'

import { FilterInputTypeahead } from '../FilterInputTypeahead/FilterInputTypeahead'

type Props = {
  size?: 'sm'
}

export const FilterInputTag = (props: Props) => {
  const { page } = usePage()

  const route = page?.route
  const tags = page?.optionsFilters?.tags

  const tagSelected = route?.tagSlug
    ? tags?.find((filterOption) => filterOption.slug === route.tagSlug) || {
        count: 0,
        label: unslugify(route.tagSlug),
        slug: route.tagSlug,
      }
    : undefined

  if (tags === undefined) return null

  return <FilterInputTypeahead {...props} filter='tagSlug' label='Tags' optionSelected={tagSelected} options={tags} />
}
